"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTheme = void 0;
var _lodestarTheme = require("../lodestarTheme");
var _ursaTheme = require("../ursaTheme");
const ThemeMap = {
  "ursa-light": _ursaTheme.ursaTheme,
  "lodestar-light": _lodestarTheme.lodestarTheme
};
/**
 * A function that returns a theme object based on a valid theme key
 * @param themeKey a valid theme key, i.e. 'ursa-light' or 'lodestar-light'
 * @returns a theme object
 */
const getTheme = themeKey => {
  return ThemeMap[themeKey];
};
exports.getTheme = getTheme;
//# sourceMappingURL=getTheme.js.map